// @ts-nocheck

import PropTypes from 'prop-types';
import './AskMe.css';

const AskMe = ({ data }) => {
  if (!data) return null;

  return <div className='pwa-askme'></div>;
};

AskMe.propTypes = {
  data: PropTypes.object
};

export default AskMe;
